module.exports = __webpack_public_path__ + "assets/share-link.9eac2f18.svg";